import {
  fetch,
  extractHubURL
} from '../../utils/dataAccess';

export function error(error) {
  return { type: 'SITE_SETTINGS_CURRENT_ERROR', error };
}

export function loading(loading) {
  return { type: 'SITE_SETTINGS_CURRENT_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'SITE_SETTINGS_CURRENT_SUCCESS', retrieved };
}

export function currentSiteSettings() {
  return dispatch => {
    dispatch(loading(true));

    return fetch('site_settings/current')
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch(success(null));
    dispatch(error(null));
    dispatch(loading(false));
  };
}
